const { getOffsetTop } = window.BAO.Utils

class SlowScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const amountToMoveY = window.BAO.MediaBreakpoints.isMd ? 100 : 60
    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / -2}px, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / 2}px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      amountToMoveY * scrollYAsAPercentageOfJourney - amountToMoveY / 2

    this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
  }
}

if (!customElements.get('slow-scroll')) {
  customElements.define('slow-scroll', SlowScroll)
}
